import React, { FC, useEffect, useRef } from 'react';
import TaskDetailDrawer from '@/common/components/business/ExpandStore/TaskDetailDrawer';
import CircleTaskDetailDrawer from '@/views/expandstore/pages/expansioncircletask/components/Detail/index';
import ExpansionFranchiseeCircleTaskDrawer from '@/views/expandstore/pages/expansionFranchiseeCircleTask/pages/detail/Drawer';
import ExpansionCircleSenmaTaskDetail from '@/views/expandstore/pages/expansioncirclesenmatask/components/Detail/index';
import LocxxTaskDetailDrawer from '@/views/expandstore/pages/expansionlocxxtask/components/LocxxTaskDetailDrawer';
import { useTenantCheckInfo } from '@/common/hook/useTenantCheckInfo';
import { useMethods } from '@lhb/hook';


export interface AllTaskDetailDrawerData {
  visible:boolean;
  id:React.Key|null;
}

interface AllTaskDetailDrawerProps{
  onRefresh: () => void;
  detailDrawerData:AllTaskDetailDrawerData;
  setShowDetailDrawer: (AllTaskDetailDrawerData) => void;
}
const AllTaskDetailDrawer:FC<AllTaskDetailDrawerProps> = ({
  onRefresh,
  detailDrawerData,
  setShowDetailDrawer,
}) => {
  const detailRef = useRef<any>();

  const {
    // /* 当前租户的拓店任务模板 */
    taskTemplateCode,
    /** 当前租户的拓店任务模板是否“加盟+直营A（基诺浦）”，未确定时为null */
    isStandardAndClusterATaskTemplate,
    /** 当前租户的拓店任务模板是否“加盟+直营B（一鸣）”，未确定时为null */
    isStandardAndClusterBTaskTemplate,
  } = useTenantCheckInfo();

  useEffect(() => {
    // 当外部传递id的时候打开详情信息
    if ((isStandardAndClusterATaskTemplate || isStandardAndClusterBTaskTemplate) && detailDrawerData.visible && detailDrawerData.id) {
      detailRef.current?.init(detailDrawerData.id);
    }
  }, [detailDrawerData.id, detailDrawerData.visible, isStandardAndClusterATaskTemplate, isStandardAndClusterBTaskTemplate]);

  const methods = useMethods({
    closeDrawer(open:boolean = false) {
      setShowDetailDrawer({
        ...detailDrawerData,
        visible: open
      });
    }

  });

  return (
    <div>
      {/* 拓店任务：加盟-新增/编辑抽屉 */}
      {taskTemplateCode === 'standardA' && <TaskDetailDrawer id={detailDrawerData.id} open={detailDrawerData.visible} setOpen={methods.closeDrawer} outterRefresh={onRefresh} />}

      {/* 拓店任务：直营-详情 */}
      {['clusterA', 'clusterB'].includes(taskTemplateCode) && detailDrawerData.visible && <CircleTaskDetailDrawer id={detailDrawerData.id} open={detailDrawerData.visible} setOpen={methods.closeDrawer} outterRefresh={onRefresh} />}

      {/* 拓店任务:加盟+直营A（基诺浦）、加盟+直营B（一鸣)-详情-抽屉 */}
      {(isStandardAndClusterATaskTemplate || isStandardAndClusterBTaskTemplate) && <ExpansionFranchiseeCircleTaskDrawer ref={detailRef} reload={onRefresh} onClose={ methods.closeDrawer} />}

      {/* 拓店任务：直营-详情 */}
      {taskTemplateCode === 'clusterC' && detailDrawerData.visible && <ExpansionCircleSenmaTaskDetail id={detailDrawerData.id} open={detailDrawerData.visible} setOpen={methods.closeDrawer} outterRefresh={onRefresh} />}

      {/* 拓店任务：Locxx 直营详情 */}
      {taskTemplateCode === 'locxxA' && <LocxxTaskDetailDrawer
        open={detailDrawerData.visible}
        taskId={detailDrawerData.id as number | string}
        onClose={methods.closeDrawer}
        reload={onRefresh}
      />}
    </div>
  );
};

export default AllTaskDetailDrawer;
